import {ApplicationType} from 'ApplicationEntry/models/ApplicationType';
import {CaseDetails, matchCaseDetailsByType} from 'ApplicationEntry/models/CaseDetails';
import {UserAssignedPolicyNumber} from 'ApplicationEntry/models/PolicyNumber';
import {PolicyTypes} from 'ApplicationEntry/models/PolicyTypes';
import {Product} from 'ApplicationEntry/models/ProductsRiders/PlanModel';
import {Async, Loading} from 'Core/models/Async';
import {createAction} from 'Shared/utilities/actionCreator';
import {reverseEnum} from 'Shared/utilities/enumUtility';
import * as G from '../models/GroupCaseDetails';
import * as NY from '../models/NewYorkCaseDetails';
import * as O from '../models/OrdinaryCaseDetails';

export enum CaseDetailsActionType {
  CHANGE_CASE_NUMBER = 'caseDetails/CHANGE_CASE_NUMBER',
  CHANGE_ACH_INDICATOR = 'caseDetails/CHANGE_ACH_INDICATOR',
  CHANGE_PRODUCT_TYPE = 'caseDetails/CHANGE_PRODUCT_TYPE',
  CHANGE_POLICY_NUMBER = 'caseDetails/CHANGE_POLICY_NUMBER',
  ASSIGN_POLICY_NUMBER = 'caseDetails/ASSIGN_POLICY_NUMBER',
  GET_PRODUCT_FAMILIES = 'caseDetails/GET_PRODUCT_FAMILIES',
  CHANGE_USER_POLICY_NUMBER = 'caseDetails/CHANGE_USER_POLICY_NUMBER',
  INSERT_POLICY_NUMBER = 'caseDetails/INSERT_POLICY_NUMBER',
  ERROR_POLICY_NUMBER = 'caseDetails/ERROR_POLICY_NUMBER',
  VALIDATE_POLICY_NUMBER = 'caseDetails/VALIDATE_POLICY_NUMBER',
  CHECK_CASE_NUMBER = 'caseDetails/CHECK_CASE_NUMBER',
  GET_MANAGED_STATUS = 'caseDetails/GET_MANAGED_STATUS',
  GET_MANAGED_STATUS_FLAG = 'caseDetails/GET_MANAGED_STATUS_FLAG',
  CHANGE_ASYNC_CASE_NUMBER = 'caseDetails/CHANGE_ASYNC_CASE_NUMBER',
  CHANGE_CASE_NAME = 'caseDetails/CHANGE_CASE_NAME',
  GET_BILLING_MODE_CASE_NUMBER = 'caseDetails/GET_BILLING_MODE_CASE_NUMBER',
  GET_SITUS_STATE_CASE_NUMBER = 'caseDetails/GET_SITUS_STATE_CASE_NUMBER',
  CHECK_CASE_NUMBER_BILLING = 'caseDetails/CHECK_CASE_NUMBER_BILLING',
  CHECK_CASE_NUMBER_ACH = 'caseDetails/CHECK_CASE_NUMBER_ACH',
  CHECK_CASE_NUMBER_BENEFICIARY = 'caseDetails/CHECK_CASE_NUMBER_BENEFICIARY',
  CHECK_USER_NAME_JSTAMP = 'caseDetails/CHECK_USER_NAME_JSTAMP',
  GET_USER_AUTH_JSTAMP = 'caseDetails/GET_USER_AUTH_JSTAMP',
  CHANGE_CASE_NUMBER_ERROR = 'caseDetails/CHANGE_CASE_NUMBER_ERROR',
  CHANGE_ACH_ERROR = 'caseDetails/CHANGE_ACH_ERROR',
  GET_POLICY_NUMBER_EXISTS = 'caseDetails/GET_POLICY_NUMBER_EXISTS',
}

export const isCaseDetailsAction = (action: any): action is CaseDetailsAction =>
  action.type in reverseEnum(CaseDetailsActionType);

export const changeCaseNumber = (caseNumber: string) =>
  createAction(CaseDetailsActionType.CHANGE_CASE_NUMBER, {caseNumber});
export const getACHIndicatorValue = (achIndicator: boolean) =>
  createAction(CaseDetailsActionType.CHANGE_ACH_INDICATOR, {achIndicator});
export const changeProductType = (productType: PolicyTypes) =>
  createAction(CaseDetailsActionType.CHANGE_PRODUCT_TYPE, {productType});
export const changePolicyNumber = (policyNumber: Async<string>) =>
  createAction(CaseDetailsActionType.CHANGE_POLICY_NUMBER, {policyNumber});
export const assignPolicyNumber = (isElectonic: boolean) =>
  createAction(CaseDetailsActionType.ASSIGN_POLICY_NUMBER, {isElectonic});
export const getProducts = (applicationType: ApplicationType) =>
  createAction(CaseDetailsActionType.GET_PRODUCT_FAMILIES, {applicationType});
export const changeUserPolicyNumber = (policyNumber: string) =>
  createAction(CaseDetailsActionType.CHANGE_USER_POLICY_NUMBER, {policyNumber});
export const insertPolicyNumber = (policyNumber: UserAssignedPolicyNumber) =>
  createAction(CaseDetailsActionType.INSERT_POLICY_NUMBER, {policyNumber});
export const policyNumberError = (policyNumber: string) =>
  createAction(CaseDetailsActionType.ERROR_POLICY_NUMBER, {policyNumber});
export const validatePolicyNumber = (policyNumber: UserAssignedPolicyNumber, policyNumberArr: Product[]) =>
  createAction(CaseDetailsActionType.VALIDATE_POLICY_NUMBER, {policyNumber, policyNumberArr});
export const checkCaseNumber = (caseNumber: string) =>
  createAction(CaseDetailsActionType.CHECK_CASE_NUMBER, {caseNumber});
export const asyncCaseNumber = (caseNumber: Async<string>) =>
  createAction(CaseDetailsActionType.CHANGE_ASYNC_CASE_NUMBER, {caseNumber});
export const changeCaseNumberError = (caseNumber: string) =>
  createAction(CaseDetailsActionType.CHANGE_CASE_NUMBER_ERROR, {caseNumber});
export const changeAchError = (notACH: boolean) =>
  createAction(CaseDetailsActionType.CHANGE_ACH_ERROR, {notACH});
export const changeCaseName = (caseName: string) => createAction(CaseDetailsActionType.CHANGE_CASE_NAME, {caseName});
export const checkCaseNumberBeneficiary = (caseNumber: string) => 
  createAction(CaseDetailsActionType.CHECK_CASE_NUMBER_BENEFICIARY, {caseNumber});
// MANAGED STATUS BOOLEAN
export const updateManagedStatus = (managedStatus: string) =>
  createAction(CaseDetailsActionType.GET_MANAGED_STATUS, {managedStatus});
export const updateManagedStatusFlag = (managedStatusFlag: boolean) =>
  createAction(CaseDetailsActionType.GET_MANAGED_STATUS_FLAG, {managedStatusFlag});
export const checkCaseNumberBillingMode = (caseNumber: string) =>
  createAction(CaseDetailsActionType.CHECK_CASE_NUMBER_BILLING, {caseNumber});
export const checkACHCaseNumber = (caseNumber: string) =>
  createAction(CaseDetailsActionType.CHECK_CASE_NUMBER_ACH, {caseNumber});
export const getBillingModefromCaseNumber = (billingMode: string) =>
  createAction(CaseDetailsActionType.GET_BILLING_MODE_CASE_NUMBER, {billingMode});
export const getSitusStatefromCaseNumber = (situsState: string) =>
  createAction(CaseDetailsActionType.GET_SITUS_STATE_CASE_NUMBER, {situsState});
export const checkUserNameAuthJStamp = (userName: string) =>
  createAction(CaseDetailsActionType.CHECK_USER_NAME_JSTAMP, {userName});
export const getUserAuthJStamp = (userNameAuth: boolean) =>
  createAction(CaseDetailsActionType.GET_USER_AUTH_JSTAMP, {userNameAuth});
export const checkPolicyNumberExists = (policyNumberExist: boolean, policyNumber: string) =>
  createAction(CaseDetailsActionType.GET_POLICY_NUMBER_EXISTS, {policyNumberExist, policyNumber});
export type CaseDetailsAction =
  | ReturnType<typeof assignPolicyNumber>
  | ReturnType<typeof changeCaseNumber>
  | ReturnType<typeof getACHIndicatorValue>
  | ReturnType<typeof changePolicyNumber>
  | ReturnType<typeof changeProductType>
  | ReturnType<typeof changeUserPolicyNumber>
  | ReturnType<typeof insertPolicyNumber>
  | ReturnType<typeof policyNumberError>
  | ReturnType<typeof validatePolicyNumber>
  | ReturnType<typeof checkCaseNumber>
  | ReturnType<typeof asyncCaseNumber>
  | ReturnType<typeof changeCaseNumberError>
  | ReturnType<typeof changeCaseName>
  | ReturnType<typeof checkCaseNumberBillingMode>
  | ReturnType<typeof checkACHCaseNumber>
  | ReturnType<typeof changeAchError>
  | ReturnType<typeof getBillingModefromCaseNumber>
  | ReturnType<typeof getSitusStatefromCaseNumber>
  | ReturnType<typeof checkUserNameAuthJStamp>
  | ReturnType<typeof getUserAuthJStamp>
  | ReturnType<typeof checkPolicyNumberExists>
  | ReturnType<typeof checkCaseNumberBeneficiary>
  | ReturnType<typeof updateManagedStatus>
  | ReturnType<typeof updateManagedStatusFlag>;

type CaseDetailsState = CaseDetails;

export default (state: CaseDetailsState, action: CaseDetailsAction): CaseDetailsState => {
  switch (action.type) {
    case CaseDetailsActionType.ASSIGN_POLICY_NUMBER:
      return matchCaseDetailsByType<CaseDetails>({
        Group: G.changePolicyNumber(new Loading()),
        Ordinary: O.changePolicyNumber(new Loading()),
        NewYork: NY.changePolicyNumber(new Loading()),
      })(state);

    case CaseDetailsActionType.CHANGE_CASE_NUMBER:
      return matchCaseDetailsByType({
        Group: G.changeCaseNumber(action.payload.caseNumber),
        Ordinary: () => state,
        NewYork: () => state,
      })(state);
    case CaseDetailsActionType.CHANGE_POLICY_NUMBER:
      return matchCaseDetailsByType<CaseDetails>({
        Group: G.changePolicyNumber(action.payload.policyNumber),
        Ordinary: O.changePolicyNumber(action.payload.policyNumber),
        NewYork: NY.changePolicyNumber(action.payload.policyNumber),
      })(state);
    case CaseDetailsActionType.CHANGE_USER_POLICY_NUMBER:
      return matchCaseDetailsByType<CaseDetails>({
        Group: G.changeUserPolicyNumber(action.payload.policyNumber),
        Ordinary: O.changeUserPolicyNumber(action.payload.policyNumber),
        NewYork: NY.changeUserPolicyNumber(action.payload.policyNumber),
      })(state);
    case CaseDetailsActionType.CHANGE_PRODUCT_TYPE:
      return matchCaseDetailsByType<CaseDetails>({
        Group: G.changeProductType(action.payload.productType),
        Ordinary: O.changeProductType(action.payload.productType),
        NewYork: NY.changeProductType(action.payload.productType),
      })(state);
    case CaseDetailsActionType.INSERT_POLICY_NUMBER:
      return matchCaseDetailsByType<CaseDetails>({
        Group: G.changeReservedPolicyNumber(action.payload.policyNumber.value),
        Ordinary: O.changeReservedPolicyNumber(action.payload.policyNumber.value),
        NewYork: NY.changeReservedPolicyNumber(action.payload.policyNumber.value),
      })(state);
    case CaseDetailsActionType.ERROR_POLICY_NUMBER:
      return matchCaseDetailsByType<CaseDetails>({
        Group: G.changePolicyNumberError(action.payload.policyNumber),
        Ordinary: O.changePolicyNumberError(action.payload.policyNumber),
        NewYork: NY.changePolicyNumberError(action.payload.policyNumber),
      })(state);
    case CaseDetailsActionType.VALIDATE_POLICY_NUMBER:
      return matchCaseDetailsByType<CaseDetails>({
        Group: G.changePolicyNumberValidation(action.payload.policyNumber.value),
        Ordinary: O.changePolicyNumberValidation(action.payload.policyNumber.value),
        NewYork: NY.changePolicyNumberValidation(action.payload.policyNumber.value),
      })(state);
    case CaseDetailsActionType.CHECK_CASE_NUMBER:
      return matchCaseDetailsByType<CaseDetails>({
        Group: G.changeAsyncCaseNumber(new Loading()),
        Ordinary: () => state,
        NewYork: () => state,
      })(state);
    case CaseDetailsActionType.CHANGE_ASYNC_CASE_NUMBER:
      return matchCaseDetailsByType<CaseDetails>({
        Group: G.changeAsyncCaseNumber(action.payload.caseNumber),
        Ordinary: () => state,
        NewYork: () => state,
      })(state);
    case CaseDetailsActionType.CHANGE_CASE_NUMBER_ERROR:
      return matchCaseDetailsByType<CaseDetails>({
        Group: G.changeCaseNumberError(action.payload.caseNumber),
        Ordinary: () => state,
        NewYork: () => state,
      })(state);
      case CaseDetailsActionType.CHANGE_ACH_ERROR:
        return matchCaseDetailsByType<CaseDetails>({
          Group: G.changeAchErrorCode(action.payload.notACH),
          Ordinary: () => state,
          NewYork: () => state,
        })(state); 
    case CaseDetailsActionType.CHANGE_CASE_NAME:
      return matchCaseDetailsByType<CaseDetails>({
        Group: G.changeCaseName(action.payload.caseName),
        Ordinary: () => state,
        NewYork: () => state,
      })(state);
    case CaseDetailsActionType.GET_BILLING_MODE_CASE_NUMBER:
      return matchCaseDetailsByType<CaseDetails>({
        Group: G.changeAsyncBillingModeCaseNumber(action.payload.billingMode),
        Ordinary: () => state,
        NewYork: () => state,
      })(state);
    case CaseDetailsActionType.GET_SITUS_STATE_CASE_NUMBER:
      return matchCaseDetailsByType<CaseDetails>({
        Group: G.changeAsyncSitusStateCaseNumber(action.payload.situsState),
        Ordinary: () => state,
        NewYork: () => state,
      })(state);
    case CaseDetailsActionType.CHECK_CASE_NUMBER_BILLING:
      return matchCaseDetailsByType<CaseDetails>({
        Group: G.changeAsyncCaseNumber(new Loading()),
        Ordinary: () => state,
        NewYork: () => state,
      })(state);
    case CaseDetailsActionType.CHECK_CASE_NUMBER_ACH:
      return matchCaseDetailsByType<CaseDetails>({
        Group: G.changeAsyncCaseNumber1(new Loading()),
        Ordinary: () => state,
        NewYork: () => state,
      })(state);
    case CaseDetailsActionType.CHECK_CASE_NUMBER_BENEFICIARY:
      return matchCaseDetailsByType<CaseDetails>({
        Group: G.changeAsyncCaseNumber2(new Loading()),
        Ordinary: () => state,
        NewYork: () => state,
      })(state);
    case CaseDetailsActionType.CHECK_USER_NAME_JSTAMP:
      return matchCaseDetailsByType<CaseDetails>({
        Group: G.checkUserNameJStamp(action.payload.userName),
        Ordinary: () => state,
        NewYork: () => state,
      })(state);
    case CaseDetailsActionType.GET_USER_AUTH_JSTAMP:
      return matchCaseDetailsByType<CaseDetails>({
        Group: G.getUserAuthJStamp(action.payload.userNameAuth),
        Ordinary: () => state,
        NewYork: () => state,
      })(state);
    case CaseDetailsActionType.CHANGE_ACH_INDICATOR:
      return matchCaseDetailsByType<CaseDetails>({
        Group: G.getACHIndicatorValue(action.payload.achIndicator),
        Ordinary: () => state,
        NewYork: () => state,
      })(state);
    case CaseDetailsActionType.GET_POLICY_NUMBER_EXISTS:
      return matchCaseDetailsByType<CaseDetails>({
        Group: G.getPolicyNumberExists(action.payload.policyNumberExist, action.payload.policyNumber),
        Ordinary: O.getPolicyNumberExists(action.payload.policyNumberExist, action.payload.policyNumber),
        NewYork: () => state,
      })(state);
    case CaseDetailsActionType.GET_MANAGED_STATUS:
      return matchCaseDetailsByType<CaseDetails>({
        Group: G.changeManagedStatus(action.payload.managedStatus),
        Ordinary: () => state,
        NewYork: () => state,
      })(state);
    case CaseDetailsActionType.GET_MANAGED_STATUS_FLAG:
      return matchCaseDetailsByType<CaseDetails>({
        Group: G.updateManagedStatusFlag(action.payload.managedStatusFlag),
        Ordinary: () => state,
        NewYork: () => state,
      })(state);
    default:
      return state;
  }
};
